import API from './../api';
import { DEFAULT_WORK_ORDER } from '../constants';

export default {

    namespaced: true,

    state() {
        return {
            vendor: null,
            localMaterialExpenses: [],
            jobTypes: [],
            accountExpenses: [],
            priorityChoices: [],
            statusChoices: [],
            owners: [],
            metadata: {},
            propertyOwners: [],
            teamMembers: [],
            formProperties: [],
            vendors: [],
            workOrderToSave: DEFAULT_WORK_ORDER,
        };
    },

    getters: {
        vendor: (state) => state.vendor,
        localMaterialExpenses: (state) => state.localMaterialExpenses,
        jobTypes: (state) => state.jobTypes,
        accountExpenses: (state) => state.accountExpenses,
        priorities: (state) => state.priorityChoices,
        statuses: (state) => state.statusChoices,
        owners: (state) => state.owners,
        metadata: (state) => state.metadata,
        propertyOwners: (state) => state.propertyOwners,
        teamMembers: (state) => state.teamMembers,
        formProperties: (state) => state.formProperties,
        vendors: (state) => state.vendors,
        workOrderToSave: (state) => state.workOrderToSave,
    },

    mutations: {
        gotVendor(state, response) {
            state.vendor = response.data;
        },
        gotJobTypes(state, response) {
            state.jobTypes = response.data;
        },
        gotAccountExpenses(state, response) {
            state.accountExpenses = response.data;
        },
        gotAccountExpense(state, response) {
            state.accountExpenses = state.accountExpenses.concat([response.data]);
        },
        gotFormOptions(state, response) {
            const { priority_choices, status_choices } = response.data;

            if (priority_choices) {
                state.priorityChoices = priority_choices;
            }
            if (status_choices) {
                state.statusChoices = status_choices;
            }
        },
        gotOwners(state, response) {
            state.owners = response.data;
        },
        gotMetadata(state, response) {
            state.metadata = response.data || {};
        },
        gotPropertyOwners(state, response) {
            state.propertyOwners = response.data;
        },
        gotTeamMembers(state, response) {
            state.teamMembers = response.data;
        },
        gotFormProperties(state, response) {
            state.formProperties = response.data;
        },
        gotVendors(state, response) {
            state.vendors = response.data;
        },
        updatedVendor(state, response) {
            state.vendor = response.data;
        },
        updatedLocalMaterialExpenses(state, data) {
            state.localMaterialExpenses = data;
        },
        updatedWorkOrderToSave(state, data = {}) {
            state.workOrderToSave = { ...state.workOrderToSave, ...data };
        },
    },

    actions: {
        async fetchJobTypes({ commit }) {
            commit('gotJobTypes', await API.get('/app/work-orders/api/job-types/'));
        },
        async fetchAccountExpenses({ commit }) {
            commit('gotAccountExpenses', await API.get('/app/work-orders/api/account-expenses/'));
        },
        async fetchFormOptions({ commit }) {
            commit('gotFormOptions', await API.get(`/app/work-orders/api/orders/form-options/`));
        },
        async fetchOwners({ commit }) {
            commit('gotOwners', await API.get(`/app/work-orders/api/orders/owners/`));
        },
        async fetchPropertyOwners({ commit }, { id }) {
            commit('gotPropertyOwners', await API.get(`/app/work-orders/api/orders/property-owners/${id}/`));
        },
        async fetchTeamMembers({ commit }) {
            commit('gotTeamMembers', await API.get(`/app/work-orders/api/orders/team-members/`));
        },
        async fetchFormProperties({ commit }) {
            commit('gotFormProperties', await API.get(`/app/work-orders/api/orders/form-properties/`));
        },
        async fetchVendors({ commit }) {
            commit('gotVendors', await API.get(`/app/work-orders/api/vendors/`));
        },
        async fetchVendor({ commit }, { id }) {
            commit('gotVendor', await API.get(`/app/work-orders/api/vendors/${id}/`));
        },
        async createAccountExpense({ commit }, payload) {
            const response = await API.post(
                `/app/work-orders/api/account-expenses/`,
                payload
            );
            commit('gotAccountExpense', response);
            return response.data;
        },
        async createVendor({ commit }, payload) {
            const response = await API.post(`/app/work-orders/api/vendors/`, payload);
            return response.data;
        },
        async updateVendor({ commit }, { id, payload }) {
            commit(
                'updatedVendor',
                await API.patch(`/app/work-orders/api/vendors/${id}/`, payload)
            );
        },
        async fetchMetadata({ commit }) {
            commit('gotMetadata', await API.get('/app/work-orders/metadata/'));
        },
        updateLocalMaterialExpenses({ commit }, payload) {
            commit(
                'updatedLocalMaterialExpenses',
                [...payload]
            );
        },
        updateWorkOrderToSave({ commit }, payload) {
            commit(
                'updatedWorkOrderToSave',
                payload
            );
        }
    },

};
